<res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
    [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs"
    [requestInfo]="requestInfo" [gridContext]="gridContext" [contextMenuOptions]="contextMenuOptions"
    [responseArrayCallback]="responseArrayCallback" [pagerVisible]="false"
    [cellDoubleClickedCallback]="cellDoubleClickedCallback" [rowClassRules]="rowClassRules"
    [updateStatusType]="updateStatusType" [hasContextMenuPermissions]="hasContextMenuPermissions">
</res-generic-grid>
<ng-template #headerTemplate>
    <button type="button" data-automation-id="patterns-add-new-button" class="secondary-button"
        (click)="addNewPattern()" *ngIf="!hasPatternsViewOnlyPermissions">
        <i class="fa fa-plus"></i>New Pattern ...</button>
</ng-template>